import request from "@/utils/request";
// 官网推广渠道上报接口
export const channelWebsite = (data) => {
  return request({
    url: "/channel/website-report",
    method: "POST",
    data,
  });
};
// 获取渠道信息接口
export const channelGetInfo = (params) => {
  return request({
    url: "/config/list",
    method: "get",
    params,
  });
};
// 登录接口
export const authLogin = (data) => {
  return request({
    url: "/auth/login",
    method: "POST",
    data,
  });
};
// 发送验证码
export const sendCodes = (data) => {
  return request({
    url: "/auth/sendCode",
    method: "POST",
    data,
  });
};
// 注册
export const authRegister = (data) => {
  return request({
    url: "/auth/register",
    method: "POST",
    data,
  });
};
// 找回密码
export const retrievePassword = (data) => {
  return request({
    url: "/auth/retrievePassword",
    method: "POST",
    data,
  });
};
